export interface PlayerState {
  pause: boolean;
}

export const enum PlayerAction {
  UpdatePause = "SetPause"
}

export const enum PlayerMutation {
  SetPause = "SetPause"
}

export const enum PlayerGetter {
  GetPause = "GetPause"
}
